export const PASSWORD_FIELD = 'password';
export const EMAIL_FIELD = 'email';
export const COMMUNICATION_CONSENT_FIELD = 'communicationConsent';
export const TERMS_AND_PRIVACY_CONSENT_FIELD = 'termsAndPrivacy';
export const PROFILE_FIELD = 'profile';
